/**
 *==================================================
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2020
 *
 *==================================================
 */
/**
 * The service response contains big number and number in the response
 * needs to be parsed to string
 */
export const numberParserRequiredServices = ["organization", "usercontext"];
